export function title( sectionTitle: string ) {
  return `${sectionTitle}${process.env.siteTitle ? ` | ${process.env.siteTitle}` : ''}`;
}
